import styled from '@emotion/styled';
import { forwardRef } from 'react';

import Icon from 'storybookConfig/stories/molecules/Icon';
import Input, { INPUT_HEIGHT } from 'storybookConfig/stories/molecules/Input';

const ICON_CONTAINER_SIZE = INPUT_HEIGHT;

const StyledInput = styled(Input)`
  padding-left: ${ICON_CONTAINER_SIZE - 6}px;
`;

type WrapperProps = Pick<EmailInputProps, 'disabled' | 'isFullWidth'>;

const Wrapper = styled.div<WrapperProps>`
  display: ${({ isFullWidth }) => (isFullWidth ? 'flex' : 'inline-flex')};
  position: relative;
  overflow: hidden;
  cursor: ${({ disabled }) => disabled && 'not-allowed'};

  ${StyledInput} {
    flex-grow: 1;
  }
`;

type DateIconProps = Pick<EmailInputProps, 'disabled'>;

const StyledIcon = styled(Icon)<DateIconProps>`
  position: absolute;
  inset: 0 auto 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${ICON_CONTAINER_SIZE}px;
  height: ${ICON_CONTAINER_SIZE}px;
`;

interface EmailInputProps extends React.ComponentProps<typeof Input> {}

/**
 * Extends an `Input` component's styling and wraps it to provide iconography. Props
 * passed to `EmailInput` will be curried to the underlying `Input` component.
 */
const EmailInput = forwardRef<HTMLInputElement, EmailInputProps>(
  ({ disabled, isFullWidth, ...inputProps }: EmailInputProps, ref) => (
    <Wrapper disabled={disabled} isFullWidth={isFullWidth}>
      <StyledIcon
        name="mail"
        color={disabled ? 'bodyTextDisabled' : 'iconDefault'}
        disabled={disabled}
      />
      <StyledInput
        ref={ref}
        type="email"
        disabled={disabled}
        isFullWidth={isFullWidth}
        {...inputProps}
      />
    </Wrapper>
  )
);

export default EmailInput;
